import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/park/group/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/park/group/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/park/group/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/park/group/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/park/group/update/v2', params, options);

export const sync = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/sync/v2', qs.stringify(params), options);

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/updateStatus/v2', params, options);

export const getCarParkList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getCarParkList/v2', Object.assign({}, options, {
    params
  }));

export const getRegionList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getRegionList/v2', Object.assign({}, options, {
    params
  }));

// 添加车位组车辆
export const addGroupCars = (params, options) =>
  request.post('/api/v4ward/car/in/park/group/save/v2', params, options);

// 查看车位组车辆管理车辆分页
export const parkGroupPage = (params, options) =>
  request.get('/api/v4ward/car/in/park/group/page/v2', Object.assign({}, options, {
    params
  }));
// 删除
export const parkGroupRemove = (params, options) =>
  request.post('/api/v4ward/car/in/park/group/remove/v2', qs.stringify(params), options);
